import { BackupOutlined as UploadIcon } from '@mui/icons-material';

const Upload = (): JSX.Element => <UploadIcon fontSize="inherit" />;

export default Upload;
